module.exports = __webpack_public_path__ + "img/小熊.88c48db4.png";